import React from 'react';
import { Section, SectionHeader, CoverageBox, replaceStr } from 'flos-react-cvi';
import { ReceiptBox } from './receipt-box';

export const Receipt = ({ resources, receiptInfo }) => (
    <Section>
        <div className="container">
            <SectionHeader>{resources['receipt.title']}</SectionHeader>
            <ReceiptBox
                resources={resources}
                insurances={receiptInfo.coverages.contents}
                dealPrice={receiptInfo.dealPrice}
                title={resources['receipt.contents.title']}
                subtitle={receiptInfo.customer.address}
                startDate={receiptInfo.currentInsurance.newInsuranceStartDate}
                terminationInfo={receiptInfo.currentInsurance}
                id="receipt-coverage-box-1"
                icon={resources['receipt.contents.icon']}
            />
            <ReceiptBox
                resources={resources}
                insurances={receiptInfo.coverages.accident}
                dealPrice={receiptInfo.dealPrice}
                title={resources['receipt.accident.title']}
                subtitle={replaceStr(resources['receipt.customerNameAndDateOfBirth'], {
                    '{name}': receiptInfo.customer.name,
                    '{date}': receiptInfo.customer.dateOfBirth
                })}
                startDate={receiptInfo.currentInsurance.newInsuranceStartDate}
                terminationInfo={receiptInfo.currentInsurance}
                id="receipt-coverage-box-2"
                icon={resources['receipt.accident.icon']}
            />
            <p className="u-Space-up--lg u-Space-down--lg" style={{ fontSize: '18px' }}>
                {resources['receipt.totalPrice']}:{' '}
                <strong>
                    {receiptInfo.dealPrice} {resources['receipt.priceRate']}
                </strong>
            </p>
            <CoverageBox
                title="Betalingsservice"
                subtitle={
                    <>
                        <span style={{ fontSize: '14px' }}>
                            {resources['receipt.accountInfo']}:{' '}
                            {`${receiptInfo.payment.regNum}-${receiptInfo.payment.accountNum}`}
                        </span>
                        <span style={{ display: 'block', marginTop: '10px', fontSize: '14px' }}>
                            {resources['receipt.paymentInfo']}
                        </span>
                        <br />
                    </>
                }
                id="receipt-coverage-box-payment-service"
                svgIcon={resources['receipt.paymentServiceIcon']}
                svgIconSize="medium"
                iconIsResponsive={false}
            />
        </div>
    </Section>
);
